import React, { useContext } from 'react';
import { Panel } from '../../components/Panel';
import CompanyFormComponent from '../../components/CompanyFormComponent';
import IconComponent from '../../components/IconComponent';
import { AppContext } from "../../context/AppContext";

export function CompanyData() {
  const {
    getRoutes
  } = useContext(AppContext);

  const ROUTE_CONFIG = getRoutes();

  return (
        <>
          <Panel
            header={
              <>
                <IconComponent iconName={ ROUTE_CONFIG.COMPANY_DATA.icon } />
                { ROUTE_CONFIG.COMPANY_DATA.title }
              </>
            }
          >
            <CompanyFormComponent />
          </Panel>
        </>
  );
}
